<template>
  <div v-loading.fullscreen.lock="loading" :element-loading-text="loadingText">
  </div>
</template>

<script>
  export default {
    name: 'logout',
    data () {
      return {
        loading: true,
        loadingText: 'Déconnexion en cours ...'
      }
    },
    created () {
      let self = this

      Promise.all([
        this.$store.dispatch('app/session/forget'),
        this.$nexus.logout()
      ]).then(() => {
        self.$router.push('/session/login')
      })
    }
  }
</script>



// WEBPACK FOOTER //
// Logout.vue?2b0b165e